import React, { useState } from 'react';
import './App.css';

function App() {
  
 

  // React uses state to manage dynamic content - similar to vanilla JS but more structured
  const [activeTab, setActiveTab] = useState('home');
  const [selectedImage, setSelectedImage] = useState(null);
  
  const galleryImages = [
    { id: 0, src: '/imgs/luz.jpg', info: 'Años Luz cover art, 2026, by Alan Díaz', link: 'https://aviramontes.bandcamp.com/album/a-os-luz' },
    { id: 1, src: '/imgs/tlahuicole.jpg', info: 'Tlahuicole Art, 2025, by Alan Díaz', link: 'https://youtu.be/DbN8QFrBvUk' },
    { id: 2, src: '/imgs/puzzles.jpg', info: 'Puzzles Art, 2025, by Alan Díaz', link: 'https://www.youtube.com/watch?v=agZ1p8onnHI' },
    { id: 3, src: '/imgs/epifanias.jpg', info: 'Epifanías, piano album, art by @davidvnun, 2023', link: "https://youtu.be/WMlSn-u1EFo" },
    { id: 4, src: '/imgs/paralisis.png', info: 'Parálisis, progressive rock EP under the name Insurrekto, art by @davidvnun, 2020', link:"https://www.youtube.com/watch?v=HRqkCY_hQiU" },
    { id: 5, src: '/imgs/barriovivo.jpg', info: 'Performring live, Barrio Vivo, photography by Aranza Vidales, 2024', link: "https://www.youtube.com/watch?v=GHUq_hqJzns" },
    { id: 6, src: '/imgs/elegy.png', info: 'Elegy, piece for SATB choir, art by Alan Díaz, 2024', link: "https://aviramontes.bandcamp.com/track/elegy" },
    { id: 7, src: '/imgs/whitedove.png', info: 'White Dove, art by @davidvnun, 2019', link:"https://www.youtube.com/watch?v=3l0KVHjsxc4" },
    { id: 8, src: '/imgs/oidas.jpg', info: 'Interview on Radio UNAM with Dulce Huet, 2023', link:"https://www.radiopodcast.unam.mx/podcast/audio/33084" },
    { id: 9, src: '/imgs/banner.jpg', info: 'Interview with Código Indie, 2020, photography by the Secretaría de Cultura', link:"https://soundcloud.com/viramontes/entrevista-insurrekto-2020" },
    { id: 10, src: '/imgs/bipolaridad.jpg', info: 'Bipolaridad for bass clarinet, 2026, cover art by Alan Díaz', link: 'https://aviramontes.bandcamp.com/track/bipolaridad' },
    { id: 11, src: '/imgs/bipolaridad2.jpg', info: '(Bi)polaridad 2026, cover art by davidvnun', link: 'https://objkt.com/tokens/KT1LxsUSpEy3EPY7TeV97RcinsozWJ4e6c8K/1' },
    { id: 12, src: '/imgs/insonora.jpg', info: 'Phi$hing at In-Sonora festival 2026 in Madrid, Spain', link: 'https://www.ied.edu/events/in-sonora-2026' },
    { id: 13, src: '/imgs/ignite.jpg', info: 'Phi$hing at Ignite the Arts festival 2025 in Canada', link: 'https://electropresence.com/en/even/47090-ignite-the-arts-2025-fixed-media-1' },
    { id: 14, src: '/imgs/aires.jpg', info: 'Phi$hing at Festival Aires Nacionales 2023 in CDMX', link: 'https://youtu.be/q5xTMiDdKFA' },
    { id: 15, src: '/imgs/electronicthinking.jpg', info: 'Phi$hing at Electronic Thinking 2026 in Weimar Germany', link: 'https://seam.hfm-weimar.de/?page_id=5971' },
    { id: 16, src: '/imgs/fimmne.jpeg', info: 'Phi$hing at Foro Internacional de Música Nueva Manuel Enríquez 2026 in CDMX', link: 'https://forodemusicanueva.inba.gob.mx/' },
  ];

  // Works data
  const works = [
    { title: 'Phi$hing - computer and performer, 2023', link: 'https://youtu.be/vF0nY8hnNgc' },
    { title: 'Los días más hermosos son efímeros - computer and wind quintet, 2026 (to be premiered)'},
    { title: 'Una memoria a través de los años - piano for 6 hands, 2026', link: 'https://youtu.be/7Gr1Slcs-Ng?t=1955', sample:"/pdfs/unamemoriaatravesdelosaños.pdf"},
    { title: 'Bipolaridad - bass clarinet', link: 'https://aviramontes.bandcamp.com/track/bipolaridad', sample:"/pdfs/bipolaridad.pdf", sheet: "https://aviramontes.bandcamp.com/merch/bipolaridad-para-clarinete-bajo-2" },
    { title: "Ujo'ob, and In Chiich - soprano and piano/guitar 2026'", link: 'https://youtu.be/7Gr1Slcs-Ng?t=2676' },
    { title: 'Ciudad sin sueño - soprano and guitar, 2025', link: 'https://youtu.be/elXLnMjCGk0?si=JssxT1j39K4iECKA&t=1172', sample:"/pdfs/ciudadsinsueño.pdf"},
    { title: 'Epifanías - piano solo, 2023', link: 'https://youtu.be/WMlSn-u1EFo' },
    { title: 'Elegy - SATB choir, 2024', link: "https://www.youtube.com/watch?v=zvjxwRnFCww" },
    { title: 'Lamento - soprano, alto and tenor, 2021', link: 'https://youtu.be/e_7iTzWINYw' },
    { title: 'Coda - tenor and guitar, 2020', link: 'https://youtu.be/k0Kbyk3ycB0' },
    { title: 'El gran inquisidor - pierrot ensemble, 2019', link: 'https://youtu.be/Fvh3XZgH154' },
    { title: 'Vidales - cello and piano, 2018', link: 'https://youtu.be/pJeypzUcktY' },
    { title: 'Raíces - string quartet, 2019', link: 'https://www.youtube.com/watch?v=IJZmf9FQGWs' },
    { title: 'Fraktal Angels - audiovisual short film, 2023', link: "https://www.youtube.com/watch?v=BSB0piP0i2s" },
    { title: 'Sólo vinimos a soñar - cello and glockenspiel, 2024'},
    { title: 'Ecos - soprano, flute, clarinet, piano and percussion, 2023', link: "https://youtu.be/g4IvgXEecAU"},
    { title: 'A Piece for Craig, classical guitar, 2016', link: "https://www.youtube.com/watch?v=48y-XKRYass", sample:"/pdfs/apieceforcraig.pdf", sheet:"https://aviramontes.bandcamp.com/merch/a-piece-for-craig"},
  ];

  // Downloads
  const [downloads, setDownloads] = useState([
  {
    id: 1,
    title: "Niña Foals 2025",
    file: "/downloads/cdp2.mp3",
    download: false,
  },
  {
    id: 2,
    title: "CDP ringtone",
    file: "/downloads/cdp.mp3",
    download: true,
  },
  // Add more tracks...
]);

 // In React, we use JSX which is a syntax extension that looks like HTML but is JavaScript
 return (
  <div className="app">
    {/* Background image - in React we typically use CSS classes rather than inline styles */}
    {/* <div className="background"></div> */}


   <div className="background"></div>
       
    
    {/* Navigation - becomes a header on mobile via CSS media queries */}
    <nav className="sidebar">
      <div className="nav-buttons">
        {/* In React, we use onClick instead of onclick */}
        <button onClick={() => setActiveTab('home')}>Home</button>
        <button onClick={() => setActiveTab('bio')}>Bio</button>
        <button onClick={() => setActiveTab('phishing')}>Phi$hing</button>
        <button onClick={() => setActiveTab('works')}>Portfolio</button>
        <button onClick={() => setActiveTab('gallery')}>Gallery</button>
        <button id='downloads' onClick={() => setActiveTab('Downloads')}>Downloads</button>
      </div>
      
      <div className="social-icons">
          {/* Using SVG files as regular images */}
          <a href="https://www.instagram.com/alejandro.virnun/" target="_blank" rel="noopener noreferrer">
            <img 
              src="/icons/instagram.svg" 
              alt="Instagram" 
              className="icon"
            />
          </a>
          
          <a href="https://aviramontes.bandcamp.com" target="_blank" rel="noopener noreferrer">
            <img 
              src="/icons/bandcamp.svg" 
              alt="Bandcamp" 
              className="icon"
            />
          </a>
          <a href="https://www.youtube.com/@alejandroviramontes8795" target="_blank" rel="noopener noreferrer">
            <img 
              src="/icons/youtube.svg" 
              alt="YouTube" 
              className="icon"
            />
          </a>
          <a href="https://open.spotify.com/artist/1kOPbnUfaN4eBQkzpTNTZG" target="_blank" rel="noopener noreferrer">
            <img 
              src="/icons/spotify.svg" 
              alt="Spotify" 
              className="icon"
            />
          </a>
          <a href="https://music.apple.com/us/artist/alejandro-viramontes/1689953679" target="_blank" rel="noopener noreferrer">
            <img 
              src="/icons/apple.svg" 
              alt="Apple Music" 
              className="icon"
            />
          </a>
          <a href="https://music.youtube.com/channel/UCRQnkeGR-5OOYRGYFqEKYSQ" target="_blank" rel="noopener noreferrer">
            <img 
              src="/icons/ytmusic.svg" 
              alt="YouTube Music" 
              className="icon"
            />
          </a>
        </div>
        
    </nav>
    <nav className='mobile-footer'>
      <div className="social-icons-mobile">
          {/* Using SVG files as regular images */}
          <a href="https://www.instagram.com/alejandro.virnun/" target="_blank" rel="noopener noreferrer">
            <img 
              src="/icons/instagram.svg" 
              alt="Instagram" 
              className="icon"
            />
          </a>
          <a href="https://aviramontes.bandcamp.com" target="_blank" rel="noopener noreferrer">
            <img 
              src="/icons/bandcamp.svg" 
              alt="Bandcamp" 
              className="icon"
            />
          </a>
          <a href="https://www.youtube.com/@alejandroviramontes8795" target="_blank" rel="noopener noreferrer">
            <img 
              src="/icons/youtube.svg" 
              alt="YouTube" 
              className="icon"
            />
          </a>
          <a href="https://open.spotify.com/artist/1kOPbnUfaN4eBQkzpTNTZG" target="_blank" rel="noopener noreferrer">
            <img 
              src="/icons/spotify.svg" 
              alt="Spotify" 
              className="icon"
            />
          </a>
          <a href="https://music.apple.com/us/artist/alejandro-viramontes/1689953679" target="_blank" rel="noopener noreferrer">
            <img 
              src="/icons/apple.svg" 
              alt="Apple Music" 
              className="icon"
            />
          </a>
          <a href="https://music.youtube.com/channel/UCRQnkeGR-5OOYRGYFqEKYSQ" target="_blank" rel="noopener noreferrer">
            <img 
              src="/icons/ytmusic.svg" 
              alt="YouTube Music" 
              className="icon"
            />
          </a>
        </div>
    </nav>

 {/* Main content area */}
 <main className="content">
        {/* Conditional rendering - in React we use JavaScript expressions to show/hide content */}
        {activeTab === 'home' && (
          <div className="home-content">
            <h1>Alejandro Viramontes Nunura</h1>
            <h2>Mexican creator, composer and educator</h2><br></br>
            <h3><a href='https://youtu.be/7Gr1Slcs-Ng' target='blank_'>Watch my recital <i>Antología del Inicio</i></a></h3>
          </div>
          
        )
        }

        {activeTab === 'bio' && (
          <div className="bio-content content-box">
            <img src="/imgs/bio.jpg" alt="Alejandro Viramontes Nunura" />
            <div className="bio-text">
              <h2>Short Biography</h2>
              <p>
              Alejandro Viramontes Nunura is a Mexican composer and educator. He graduated with a degree in composition from Berklee College of Music in 2019. His work has been presented in several countries, festivals and competitions such as: <i>In-Sonora 2026</i> in Spain, <i>Ignite the arts 2025</i> in Canada, <i>International Antonín Dvorák Composition Competition 2019</i> in the Czech Republic, SEAMUS 2019 in the United States, <i>The American Prize</i> in 2020, among others. He has also presented works in various Mexican concert halls such as Bellas Artes, the Sala Hermilo Novelo at the Ollin Yoliztli, the CMMAS in Morelia and other important venues. <i>Phi$hing</i>, his groundbreaking piece for computer, is scheduled to be performed this year in Bellas Artes and at the Festival <i>Electronic Thinking</i> in Germany. He graduated with a master's degree in 2026 under the tutelage of Dr. Julio Estrada with his work <i>Ecos</i> and his thesis <i>¿Cayendo o Flotando?</i>
              </p>
            </div>
            <div className='bio-downloads'>
      <a href="/pdfs/epk.pdf" download className="download-btn">
      Download EPK
      </a>
      <a href="/pdfs/cv.pdf" download className="download-btn">
      Download CV
      </a>
    </div>
          </div>
        )}

      {activeTab === 'gallery' && (
          <div className="gallery-content">
            {/* In React, we use map() to render lists of items */}
            <div className="gallery-grid">
              {galleryImages.map((image) => (
                <div 
                  key={image.id} 
                  className="gallery-item"
                  onClick={() => setSelectedImage(image)}
                >
                  <img src={image.src} alt={`Gallery item ${image.id}`} />
                </div>
              ))}
            </div>
          </div>
        )}

{activeTab === 'works' && (
  <div className="works-content content-box">
    <h2>Portfolio</h2>
    <ul>
      {works.map((work, index) => (
        <li key={index}>
          {work.title}
          {/* Only show "Listen" if link exists */}
          {work.link && (
            <>, <a href={work.link} target="_blank" rel="noopener noreferrer">Listen</a></>
          )}
          {work.sample && (
            <>, <a href={work.sample} download>Download Sample</a></>
          )}
          {work.sheet && (
            <>, <a href={work.sheet} target="_blank" rel="noopener noreferrer" className="sheet-link">Buy Sheet Music</a></>
          )}
        </li>
      ))}
    </ul>
  </div>
)}

        {activeTab === 'phishing' && (
          <div className="phishing-content content-box">
            <img src="/imgs/phishing.gif" alt="Phi$hing" className="phishing-gif" />
            <div className="phishing-text">
              <h2>Phi$hing</h2>
              <p>
              !!!🎉Congratulations🎉!!! You have been selected to win an amazing prize💰😲💰. To claim it, just connect, click on the emoji below and follow these simple steps. You won't want to miss this opportunity to make your dreams come true!
              </p>
              <div className="social-icons-phishing">
                <a href="https://phishing.alejandroviramontes.com" target="_blank" rel="noopener noreferrer">
                <img 
                src="/icons/ps.png" 
                alt="phi$hing" 
                className="icon"
                />
                </a>
        </div>
            </div>
          </div>
        )}

       {activeTab === 'Downloads' && (
      <div className="works-content content-box">
        <h2>Downloads</h2>
        <ul>
          {downloads.map((track) => (
            <li key={track.id} className="download-item">
              <div className="track-info">
                <a 
                  href={track.file} 
                  download >
                  Download <i>{track.title}</i>
                </a>
                <audio controls className="audio-preview">
                  <source src={track.file} type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio>
              </div>
            </li>
          ))}
        </ul>
      </div>)} 
      </main>

 {/* Modal for gallery images */}
 {selectedImage && (
        <div className="image-modal">
          <div className="modal-overlay" onClick={() => setSelectedImage(null)}></div>
          <div className="modal-content">
            <img src={selectedImage.src} alt="Full size" />
            <p className="image-info">{selectedImage.info}</p><br></br>
            <a className="image-link"  href={selectedImage.link} target="_blank" rel="noopener noreferrer">More information</a>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;